import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductServiceBrandComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    productKit: any;

    @Prop()
    productsOfGrouped: flights.ProductModel[];

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    @Prop()
    forwardFlag: boolean;

    @Prop({ default: api.ProductChoiceType.manualAccepted })
    choiceType: api.ProductChoiceType;

    @Prop()
    location?: string;

    accumIds: any = [];

    get productsAccum() {
        return this.productKit.products.filter(item => item.productId || item.productId == 0);
    }

    mounted() {
        this.sortByOrder();
        this.notStandartChecker();

        const { products, stepOnForm } = this.productKit;

        for (const product of products) {
            if (this.location === 'catchup') {
                (<any>this).$ga.sendEvent(
                    'product.catchup.svb',
                    'shown',
                    `product.catchup.svb.kit${product.kitId}.id${product.productId}`,
                    this.gaParams
                );
            } else {
                (<any>this).$ga.sendEvent(
                    'product.svb',
                    'display',
                    `product.svb.step${stepOnForm}.kit${product.kitId}.id${product.productId}`,
                    this.gaParams
                );
            }
        }
    }

    nameGetter(id) {
        if(this.reservation.products){
            const res = this.reservation.products.find(item => item.product.id == id);
            if (res) {
                return res.product.name;
            }
        }
    }

    priceGetter(id) {
        if (this.reservation.products) {
            const res = this.reservation.products.find(item => item.product.id == id);
            if (res) {
                return res.product.billingPrice;
            }
        }
    }

    getCurrentCode(id) {
        if (this.reservation.products) {
            const res = this.reservation.products.find(item => {
                return item.product.id == id;
            });
            return res?.product?.currencyCode;
        }
    }
    selectChecker(id) {
        return this.accumIds.includes(id);
    }

    sortByOrder(){
        if (this.productKit.products) {
            this.productKit.products.sort((a, b) =>{
                return a.sortOrder == b.sortOrder ? 0 : (a.sortOrder > b.sortOrder ? 1 : -1);
            });
        }
    }

    onProductChoose(product, kit) {
        const stepOnForm = this.reservation.brandedProductKits ? this.reservation.brandedProductKits[0].stepOnForm : '0';
        if (this.location === 'catchup') {
            (<any>this).$ga.sendEvent(
                'product.catchup.svb',
                'btn.ok',
                `product.catchup.svb.kit${kit}.id${product}`,
                this.gaParams
            );
        } else {
            (<any>this).$ga.sendEvent(
                'product.svb',
                'btn.ok',
                `product.svb.step${stepOnForm}.kit${kit}.id${product}`,
                this.gaParams
            );
        }

        if (product == 0) {
            this.onProductChooseStandart();
            return 0;
        }

        const resultPackage = this.reservation.products.find(item => item.product.id == product);
        if (resultPackage !== null && resultPackage !== undefined) {
            resultPackage.choiceType = this.choiceType;
            if (resultPackage.product.internalProductIds) {
                try {
                    new api.RetailRocket().productSelected({
                        flightKey: api.RetailRocketCL.flightKey,
                        productId: resultPackage.product.id
                    });
                }
                catch (error) {
                    console.log(error);
                }
            }
        }

        this.productsAccum.forEach(item => {
            this.reservation.products.find(productItem => productItem.product.id == product)!.selected = true;
            const result = this.reservation.products.find(productItem => productItem.product.id !== product && item.productId == productItem.product.id);
            if (result) {
                result.selected = false;
            }
        });
        this.notStandartChecker();
        this.$emit('close-popup');
    }

    onProductChooseStandart() {
        this.productKit.products.forEach(item => {
            const result = this.reservation.products.find(productItem => productItem.product.id == item.productId);
            if (result) {
                result.selected = false;
            }
        });
        this.notStandartChecker();
        this.$emit('close-popup');
    }
    notStandartChecker() {
        let flag = true;
        this.productsAccum.forEach(item => {
            const res = this.reservation.products.find(product => {
                return product.product.id == item.productId;
            });
            if (res !== undefined && res !== null && flag !== false) {
                if(res.selected == true) {
                    this.accumIds = [res.product.id];
                    flag = false;
                } else if (this.forwardFlag !== true) {
                    this.accumIds = [0];
                }
            }
        });
    }
}
